import { ListConductorFilters } from './filters';
import { ListConductorQueryParams } from './navigation-provider';

export function getListPropertiesFromQueryParams(
  params: ListConductorQueryParams,
  prefix: string,
  keys: string[],
  decodeRequired = false
) {
  if (!keys) {
    return {};
  }

  return keys.reduce((dict, key) => {
    let param = params[getQueryParamKey(prefix, key)];

    if (typeof param === 'undefined' || params === null) {
      return dict;
    }
    param = decodeRequired ? getDecodedFilter(param as string) : param;
    return Object.assign(dict, { [key]: param });
  }, {});
}

export function getQueryParamKey(prefix: string, key: string) {
  return `${prefix}_${key}`;
}

export function getEncodedFilter(filters: ListConductorFilters, key: string) {
  const filter = filters.find(_filter => _filter.filter === key);
  if (filter) {
    return btoa(JSON.stringify(filter));
  }
  return undefined;
}

export const getDecodedFilter = (encodedFilter: string) => {
  return JSON.parse(atob(encodedFilter));
};
